import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=2486e0e1&"
import script from "./TooltipButton.vue?vue&type=script&lang=ts&"
export * from "./TooltipButton.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipButton.vue?vue&type=style&index=0&id=2486e0e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports